class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest.json?q=${searchTerm}&resources[limit]=4&resources[limit_scope]=each`)
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }
        // Passo 1: Mude de .text() para .json() para processar os dados corretamente
        return response.json(); 
      })
      .then((data) => {
        // Passo 2: Agora 'data' é um objeto JSON, não mais um texto HTML
        const products = data.resources.results.products;
        
        // Se não houver produtos, não faz nada ou mostra uma mensagem
        if (products.length === 0) {
          this.close();
          return;
        }
        // Passo 3: Crie o HTML dinamicamente a partir dos dados dos produtos
        const resultsMarkup = products.map((product) => {
          // Para cada produto, cria um item de lista com link, imagem e título
          // ATENÇÃO: A estrutura do HTML (classes, tags) deve ser a que você deseja.
          // Este é apenas um exemplo.
          return `
            <li class="predictive-search__item p-4 hover:bg-neutral-200">
              <a href="${product.url}" class="predictive-search__link flex gap-4">
                <img src="${product.image}" alt="${product.title}" width="50" height="50">
                <div class="flex flex-col gap-2">
                  <p class="predictive-search__item-title text-primary font-bold">${product.title}</p>
                  <p class="predictive-search__item-price text-primary">R$${product.price}</p> 
                </div>
              </a>
            </li>
            <hr class="w-[calc(100%-32px)] mx-auto h-[1px] bg-neutral-400">
          `;
        }).join(''); // Junta todos os itens <li> em uma única string
  
        // Coloca o HTML gerado dentro de uma <ul> no seu contêiner de resultados
        const allResultsUrl = `/search?q=${encodeURIComponent(searchTerm)}`;
        const footerMarkup = `
          <div class="predictive-search__footer p-4 text-center">
            <a href="${allResultsUrl}" class="button button-outline button-primary w-full">
              Ver todos os resultados
            </a>
          </div>
        `;
        this.predictiveSearchResults.innerHTML = `
          <ul class="predictive-search__results-list">${resultsMarkup}</ul>
          ${footerMarkup}
        `;
        this.open();
      })
      .catch((error) => {
        console.error(error);
        this.close();
      });
  }

  open() {
    this.predictiveSearchResults.style.display = "block";
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);
